/** @jsx jsx */
import { jsx } from '@emotion/core';
import NavLink from './NavLink';
import {
  HeaderNav,
  HeaderNavLink,
} from '@zapier/product-dev-platform/src/types';

type NavProps = {
  config: HeaderNav;
};
const mainNavCss = {
  order: 2,
  ul: {
    margin: 0,
    padding: 0,
  },
  li: {
    listStyle: 'none',
    display: 'block',
    margin: '1em 20px',
  },
  '@media (min-width: 1079px)': {
    flex: '1',
    order: 0,
    ul: {
      display: 'flex',
    },
    li: {
      margin: '0 12px',
      ':first-of-type': {
        marginLeft: 0,
      },
    },
  },
};

const Nav = ({ config }: NavProps) => (
  <nav aria-label="Primary navigation" css={mainNavCss}>
    <ul>
      {config.map((link: HeaderNavLink) => (
        <li key={link.label}>
          <NavLink {...link} />
        </li>
      ))}
    </ul>
  </nav>
);

export default Nav;
